import React, { FC, HTMLAttributes, useState } from "react"
import { HR, Spacer } from "../Atoms"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../Bodies"
import { SharedInputCssProps } from "./StyledInputs"
import { useFormContext } from "react-hook-form"

export type FormAccordionSingleSelectProps = {
  placeholderText?: string
  options: OptionProps[]
  name?: string
} & Partial<SharedInputCssProps> &
  HTMLAttributes<HTMLInputElement>

type OptionProps = {
  id: string
  title: string
  body: string
}

const FormAccordionSingleSelect = React.forwardRef<HTMLInputElement, FormAccordionSingleSelectProps>(
  ({ options, name }: FormAccordionSingleSelectProps, ref) => {
    const [openedOptions, setOpenedOptions] = useState({})
    const onChildClickOpen = (id) => {
      setOpenedOptions({
        PATHFINDING: false,
        PRESERVATION: false,
        IUI: false,
        IVF: false,
        ADOPTION: false,
        GC: false,
        [id]: !openedOptions[id]
      })
    }

    const { watch } = useFormContext()
    return (
      <>
        {options.map((accordion) => {
          return (
            <div key={accordion.id}>
              <input hidden name={name} id={`accordion-${accordion.id}`} type="radio" value={accordion.id} ref={ref} />
              <FormAccordionSingleSelectOption
                id={accordion.id}
                isOpen={openedOptions[accordion.id]}
                title={accordion.title}
                body={accordion.body}
                name={name}
                onChildClickOpen={onChildClickOpen}
                isSelected={watch(name) === accordion.id}
              />
            </div>
          )
        })}
      </>
    )
  }
)

type JourneyArrowProps = {
  isOpen: boolean
}

const OpenJourneyArrow: FC<JourneyArrowProps> = ({ isOpen }) => {
  return (
    <img
      className={`animate-all vmid ${isOpen ? "rotate-180" : ""}`}
      alt={isOpen ? "close" : "open"}
      src={`/images/icn-upwards-arrow.png`}
      style={{ minWidth: "17px" }}
    />
  )
}

type FormAccordionSingleSelectOption = {
  id: string
  title: string
  body: string
  isOpen: boolean
  isSelected: boolean
  onChildClickOpen: (index: string) => void
  name: string
}

const FormAccordionSingleSelectOption: FC<FormAccordionSingleSelectOption> = ({
  id,
  title,
  body,
  isSelected,
  name,
  onChildClickOpen,
  isOpen
}) => {
  const { setValue, trigger } = useFormContext()

  const onChildClickSelected = (id) => {
    setValue(name, id)
    trigger()
  }

  return (
    <div
      id={`form-accordion-single-select-${id}`}
      onClick={() => onChildClickSelected(id)}
      className={`pointer bg-${isSelected ? "old-lace" : "white"} animate-all hover-bg-old-lace`}
    >
      <div style={{ minHeight: 60 }} className="pl35-s pl45-ns">
        <div className="flex pv3">
          <div className="carrot-orange hover-black animate-all flex-auto">
            <div>
              <H3>{title}</H3>
            </div>

            {isOpen && (
              <div className="carrot-orange hover-black animate-all flex-auto">
                <Spacer height={0.5} />
                <BodySmall>{body}</BodySmall>
              </div>
            )}
          </div>

          <div onClick={() => onChildClickOpen(id)} className="ph4 ph45-ns pt1">
            <OpenJourneyArrow isOpen={isOpen} />
          </div>
        </div>
      </div>
      <div className="pl35-s pl45-ns">
        <HR color="black-05" />
      </div>
    </div>
  )
}

export { FormAccordionSingleSelect }
